(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bdp-flocage"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bdp-flocage')) {
    customElements.define('bdp-flocage', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const choice = this.querySelector('[data-flocage-choice]');
        const fields = this.querySelector('[data-flocage-fields]');
        const form = this.closest('form');
        if (!choice || !fields || !form) return;
        choice.disabled = false;
        const sync = () => {
          const enabled = choice.value === 'yes';
          fields.hidden = !enabled;
          fields.disabled = !enabled;
          form.toggleAttribute('data-bdp-personalized', enabled);
        };
        choice.addEventListener('change', sync, options);
        form.addEventListener('submit', (event) => {
          if (choice.value !== 'yes') return;
          const name = this.querySelector('[data-flocage-name]');
          name.value = name.value.trim();
          if (!form.reportValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { ...options, capture: true });
        sync();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
